import { Bookmark, BookmarkBorder } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { useBookmarkManagement } from '@/hooks';
import { EVENT_CONSTANTS } from '@/services';
import { Referrer } from '@/types';

import { episodeBannerStyles as styles } from '../../styles';

export const BookmarkButton = ({
  episodeId,
  referrer,
}: {
  episodeId?: string;
  referrer: Referrer;
}) => {
  if (!episodeId) return null;

  const { toggleBookmark, isBookmarked } = useBookmarkManagement({
    episodeId,
    location: { ...referrer, button: EVENT_CONSTANTS.BUTTON.BOOKMARK },
    referrer,
  });

  return (
    <IconButton
      sx={styles.bookmarkIconButton}
      disableRipple
      aria-label={`${isBookmarked ? 'Remove' : 'Add'} bookmark`}
      onClick={e => {
        e?.preventDefault();
        e?.stopPropagation();
        toggleBookmark();
      }}>
      {isBookmarked ? (
        <Bookmark sx={styles.bookmarkIcon} />
      ) : (
        <BookmarkBorder sx={styles.bookmarkIcon} />
      )}
    </IconButton>
  );
};
